const SUCCESS = 10000
const NO_LOGIN = 50002
export default {
  SUCCESS,
  NO_LOGIN
}
